module.exports = __webpack_public_path__ + "img/shamanz-bg.6bfbceac.jpg";